/* eslint-disable better-mutation/no-mutation */
/**
 * Debounce function
 * Borrowed from underscore;
 */
export const debounce = function (func, wait, immediate) {
    let timeout;
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this,
            args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
};
